module.exports = _;


/*****************
 ** WEBPACK FOOTER
 ** external "_"
 ** module id = 5
 ** module chunks = 0 1 2
 **/